import React, { createContext, useContext, useState, useEffect } from 'react';

const FeatureFlagContext = createContext();

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within FeatureFlagProvider');
  }
  return context;
};

export const FEATURES = {
  DASHBOARD: 'dashboard',
  PATIENTS: 'patients',
  APPOINTMENTS: 'appointments',
  OPD: 'opd',
  IPD: 'ipd',
  PHARMACY: 'pharmacy',
  LAB: 'lab',
  BILLING: 'billing',
  INVENTORY: 'inventory',
  HR: 'hr',
  DOCUMENTS: 'documents',
  AUDIT: 'audit',
  USERS: 'users',
  MY_CALENDAR: 'my_calendar',
  ROLE_MANAGEMENT: 'role_management',
};

const DEFAULT_FLAGS = {
  [FEATURES.DASHBOARD]: true,
  [FEATURES.PATIENTS]: true,
  [FEATURES.APPOINTMENTS]: true,
  [FEATURES.OPD]: true,
  [FEATURES.IPD]: true,
  [FEATURES.PHARMACY]: true,
  [FEATURES.LAB]: true,
  [FEATURES.BILLING]: true,
  [FEATURES.INVENTORY]: true,
  [FEATURES.HR]: true,
  [FEATURES.DOCUMENTS]: true,
  [FEATURES.AUDIT]: true,
  [FEATURES.USERS]: true,
  [FEATURES.MY_CALENDAR]: true,
  [FEATURES.ROLE_MANAGEMENT]: true,
};

export const FeatureFlagProvider = ({ children }) => {
  const [features, setFeatures] = useState(DEFAULT_FLAGS);

  useEffect(() => {
    const savedFeatures = localStorage.getItem('hms-features');
    if (savedFeatures) {
      try {
        setFeatures(JSON.parse(savedFeatures));
      } catch (e) {
        console.error('Failed to parse feature flags', e);
      }
    }
  }, []);

  const toggleFeature = (feature) => {
    setFeatures(prev => {
      const newFeatures = { ...prev, [feature]: !prev[feature] };
      localStorage.setItem('hms-features', JSON.stringify(newFeatures));
      return newFeatures;
    });
  };

  const isFeatureEnabled = (feature) => {
    return features[feature] === true;
  };

  return (
    <FeatureFlagContext.Provider value={{ features, toggleFeature, isFeatureEnabled }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};